import {StyledSplashScreen} from './styles'

export function SplashScreenComponent() {
  return (
    <StyledSplashScreen>
      <img src="https://media.graphassets.com/DZQaA7KqSEGblz72jY34" alt="Urbit logo" />
      <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
    </StyledSplashScreen>
  )
}